// extracted by mini-css-extract-plugin
module.exports =  {"hidden":"IconsProvider-module__hidden___vu9u8"};